import { MultiLevelCategory } from '@shopby/shop-sdk'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getCategories } from '../../api/product'
import '../../css/Category.css'
import { slideInDown, slideLeft, slideOutUp, slideRight } from '../../js/animation'
import { RNPostMessage, AFWebLinkType, sendSetAppsflyerEvent } from '../../js/postMessage'
import { useAppContext } from '../provider/AppProvider'
import { useMyContext } from '../provider/MyProvider'

// 이미지 경로
const imgURL = '/images'

interface PropsType {
  isCategoryModal: boolean
  customClose?: boolean
  setIsCategoryModal: React.Dispatch<React.SetStateAction<boolean>>
}

/**
 * 모달 팝업 - 메뉴 카테고리
 */

export default function ModalCategory({ isCategoryModal, setIsCategoryModal, customClose }: PropsType) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [oneDepItem, setOneDepItem] = useState<MultiLevelCategory[]>() //1dep 아이템
  const [oneDepNo, setOneDepNo] = useState<number>() //1dep 선택된것
  const [twoDepItem, setTwoDepItem] = useState<MultiLevelCategory[]>() //2dep 아이템
  const [twoDepNo, setTwoDepNo] = useState<number>() //2dep 선택된것
  const [threeDepItem, setThreeDepItem] = useState<MultiLevelCategory[]>() //3dep 아이템
  const [threeDepArray, setThreeDepArray] = useState<MultiLevelCategory[]>()
  const [threeDepNo, setThreeDepNo] = useState<number>() //3dep 선택된것
  const [oneTitle, setOneTitle] = useState<string>()
  const [twoTitle, setTwoTitle] = useState<string>()
  const [isBrand, setIsBrand] = useState<boolean>(false)

  const currentUrl = window.location.pathname
  const { isAppView } = useAppContext()
  const { scrollHeader } = useMyContext()

  const navigate = useNavigate()
  const closeModal = () => {
    setClosing(true)
    setTimeout(() => {
      document.getElementsByTagName('body')[0].style.overflow = ''
      setIsCategoryModal(false)
      setClosing(false)
    }, 280)
  }

  const handleClickOutside = (event: any) => {
    const categoryBox = document.querySelector('.on_pc_category')
    const categoryBtn = document.querySelector('.header_category_btn')
    if (categoryBox && categoryBtn) {
      if (!categoryBox?.contains(event.target || null) && !categoryBtn?.contains(event.target)) {
        closeModal()
      }
    }
  }

  useEffect(() => {
    if (isCategoryModal) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    }
  }, [isCategoryModal])
  //1dep카테고리 가져오기용

  useEffect(() => {
    getCategories()
      .then((res) => {
        setOneDepItem(res.data?.multiLevelCategories)
        if (res.data?.multiLevelCategories?.[0]?.categoryNo) {
          setOneDepNo(res.data?.multiLevelCategories?.[0]?.categoryNo)
        }
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect((): void => {
    if (oneDepItem?.length !== 0) {
      const result = oneDepItem?.filter((el) => {
        if (el.categoryNo === oneDepNo) {
          return el
        }
      })
      setTwoDepItem(result?.[0]?.children)
      if (result?.[0]?.children?.[0]?.categoryNo) {
        setTwoDepNo(result[0]?.children?.[0]?.categoryNo)
      }
    }
  }, [oneDepNo])

  useEffect(() => {
    if (twoDepItem?.length !== 0) {
      const result = twoDepItem?.filter((el) => {
        if (el.categoryNo === twoDepNo) {
          return el
        }
      })

      if (result?.[0] && result?.[0]?.children?.length === 0) {
        setThreeDepNo(result[0]?.categoryNo)
      } else if (result?.[0] && result?.[0]?.children?.[0]?.categoryNo) {
        setThreeDepNo(result?.[0]?.children[0]?.categoryNo)
      }
      setThreeDepArray(result?.[0]?.children)
      setThreeDepItem([])
    }
  }, [twoDepNo])

  useEffect(() => {
    if (threeDepArray) {
      setThreeDepItem(threeDepArray)
    }
  }, [threeDepArray])

  useEffect(() => {
    if (customClose) closeModal()
  }, [customClose, closeModal])

  useEffect(() => {
    if (oneDepItem) {
      if (oneDepItem[0]?.label === '브랜드') {
        setIsBrand(true)
      } else {
        setIsBrand(false)
      }
    }
  }, [oneDepItem])

  // 카테고리 메뉴 외 닫힘 기능
  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (oneDepItem?.length !== 0 && twoDepItem?.length !== 0) {
      setOneTitle(oneDepItem?.[0]?.label)
      setTwoTitle(twoDepItem?.[0]?.label)
    }
  }, [oneDepItem, twoDepItem])

  if (!isCategoryModal) return null

  return isMobile ? (
    <ModalWrap $closing={closing}>
      <div className='category_container'>
        {/* 헤더 */}
        <div className='category_header'>
          <p className='category_title'>카테고리</p>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_category_close.png`} alt='닫기' />
          </button>
        </div>
        {/* 탭 바 */}
        <div className='tab_container'>
          <SwiperWrap
            slidesPerView={'auto'}
            spaceBetween={8}
            modules={[FreeMode]}
            freeMode={false}
            centeredSlidesBounds={true}
            slideToClickedSlide={true}
          >
            {oneDepItem?.map((el) => {
              const excludedLabels = ['핫딜', '100원샵']
              if (el.label && excludedLabels.includes(el.label)) return null

              return (
                <SwiperSlideItem key={el.label}>
                  <button
                    className={el.categoryNo === oneDepNo ? 'one_depth on' : 'one_depth'}
                    onClick={() => {
                      if (el.label === '아울렛') {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/outlet`,
                          })
                        } else {
                          navigate('/outlet')
                        }

                        closeModal()
                        return
                      }
                      setOneDepNo(el.categoryNo)
                      setOneTitle(el.label)
                    }}
                    key={el.categoryNo}
                  >
                    {el.label}
                  </button>
                </SwiperSlideItem>
              )
            })}
            <SwiperSlideItem>
              <button
                className='one_depth'
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitionlist`,
                    })
                  } else {
                    navigate('/exhibitionlist')
                  }
                  closeModal()
                  return
                }}
              >
                기획전
              </button>
            </SwiperSlideItem>
          </SwiperWrap>
        </div>
        {/* 내용 */}
        <div className='category_row_wrap'>
          {/* 모바일 카테고리 2depth */}
          <div className='two_depth_wrap'>
            {twoDepItem?.map((el) => {
              return (
                <div
                  className={el.categoryNo === twoDepNo ? 'two_depth on' : 'two_depth'}
                  key={el.categoryNo}
                  onClick={() => {
                    setTwoDepNo(el.categoryNo)
                    setTwoTitle(el.label)
                  }}
                >
                  {el.label}
                </div>
              )
            })}
          </div>

          {/* 모바일 3depth */}
          <div className='three_depth_wrap'>
            <a
              href={`/category/${twoDepNo}/${twoDepNo}/${twoDepNo}`}
              className='three_depth'
              onClick={(e) => {
                e.preventDefault()
                const gtmNavigateClick: DataLayerArgs = {
                  dataLayer: {
                    event: 'click_navigation',
                    event_info: {
                      click_location: 'hamburger',
                      click_category: oneTitle,
                      click_sub_category: twoTitle,
                      click_label: '전체',
                    },
                  },
                }
                if (isAppView) {
                  sendSetAppsflyerEvent({
                    eventName: 'click_navigation',
                    eventType: {
                      click_location: 'hamburger',
                      click_category: oneTitle,
                      click_sub_category: twoTitle,
                      click_label: '전체',
                    },
                  })
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/category/${twoDepNo}/${twoDepNo}/${twoDepNo}`,
                  })
                } else {
                  TagManager.dataLayer(gtmNavigateClick)
                  navigate(`/category/${twoDepNo}/${twoDepNo}/${twoDepNo}`)
                }
                closeModal()
              }}
            >
              전체
            </a>
            {threeDepItem?.map((el) => {
              return (
                <a
                  className='three_depth'
                  href={`/category/${twoDepNo}/${el.categoryNo}/${el.categoryNo}`}
                  key={threeDepNo}
                  onClick={(e) => {
                    e.preventDefault()
                    const gtmNavigateClick: DataLayerArgs = {
                      dataLayer: {
                        event: 'click_navigation',
                        event_info: {
                          click_location: 'hamburger',
                          click_category: oneTitle,
                          click_sub_category: twoTitle,
                          click_label: el.label,
                        },
                      },
                    }
                    if (isAppView) {
                      sendSetAppsflyerEvent({
                        eventName: 'click_navigation',
                        eventType: {
                          click_location: 'hamburger',
                          click_category: oneTitle,
                          click_sub_category: twoTitle,
                          click_label: el.label,
                        },
                      })
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/category/${twoDepNo}/${el.categoryNo}/${el.categoryNo}`,
                      })
                    } else {
                      TagManager.dataLayer(gtmNavigateClick)
                      navigate(`/category/${twoDepNo}/${el.categoryNo}/${el.categoryNo}`)
                    }
                    closeModal()
                  }}
                >
                  {el.label}
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </ModalWrap>
  ) : (
    // PC
    <ModalWrap $closing={closing} className={scrollHeader.current ? 'on_pc_category pc_on' : 'on_pc_category'}>
      <div className={currentUrl === '/' ? 'category_container home' : 'category_container'}>
        <div className='category'>
          <div className='one_depth'>
            {oneDepItem?.map((el) => {
              if (el.label === '핫딜') {
                return null
              }
              return (
                <button
                  onClick={() => {
                    if (el.label === '아울렛') {
                      navigate('/outlet')
                      closeModal()
                      return
                    }
                    if (el.label === '브랜드') {
                      setIsBrand(true)
                    } else {
                      setIsBrand(false)
                    }
                    setOneDepNo(el.categoryNo)
                  }}
                  key={el.categoryNo}
                  className={el.categoryNo === oneDepNo ? 'on' : ''}
                >
                  {el.label}
                </button>
              )
            })}
            <button
              className='one_depth'
              onClick={() => {
                navigate('/exhibitionlist')
                closeModal()
                return
              }}
            >
              기획전
            </button>
          </div>
          <div className={isBrand ? 'two_depth brand' : 'two_depth'}>
            {isBrand ? (
              <>
                {twoDepItem?.map((el, index) => {
                  return (
                    <div className='three_depth_item' key={index}>
                      <Link
                        className='tit_button'
                        to={`/category/${el.categoryNo}/${el.categoryNo}/${el.categoryNo}`}
                        key={el.categoryNo}
                        onClick={() => {
                          const gtmNavigateClick: DataLayerArgs = {
                            dataLayer: {
                              event: 'click_navigation',
                              event_info: {
                                click_location: 'hamburger',
                                click_category: oneTitle,
                                click_sub_category: twoTitle,
                                click_label: el.label,
                              },
                            },
                          }
                          if (isAppView) {
                            sendSetAppsflyerEvent({
                              eventName: 'click_navigation',
                              eventType: {
                                click_location: 'hamburger',
                                click_category: oneTitle,
                                click_sub_category: twoTitle,
                                click_label: el.label,
                              },
                            })
                          } else {
                            TagManager.dataLayer(gtmNavigateClick)
                          }
                          closeModal()
                        }}
                      >
                        {el.label}
                      </Link>
                    </div>
                  )
                })}
              </>
            ) : (
              <>
                {twoDepItem?.map((el, index: number) => {
                  return (
                    <div className='two_depth_item' key={index}>
                      <Link
                        className='tit_button'
                        to={`/category/${el.categoryNo}/${el.categoryNo}/${el.categoryNo}`}
                        key={el.categoryNo}
                        onClick={() => {
                          const gtmNavigateClick: DataLayerArgs = {
                            dataLayer: {
                              event: 'click_navigation',
                              event_info: {
                                click_location: 'hamburger',
                                click_category: oneTitle,
                                click_sub_category: twoTitle,
                                click_label: el.label,
                              },
                            },
                          }
                          if (isAppView) {
                            sendSetAppsflyerEvent({
                              eventName: 'click_navigation',
                              eventType: {
                                click_location: 'hamburger',
                                click_category: oneTitle,
                                click_sub_category: twoTitle,
                                click_label: el.label,
                              },
                            })
                          } else {
                            TagManager.dataLayer(gtmNavigateClick)
                          }
                          closeModal()
                        }}
                      >
                        {el.label}
                      </Link>
                      <div className='three_depth_item'>
                        {el.children?.map((element) => (
                          <Link
                            to={`/category/${el.categoryNo}/${element.categoryNo}/${element.categoryNo}`}
                            key={element.categoryNo}
                            onClick={() => {
                              const gtmNavigateClick: DataLayerArgs = {
                                dataLayer: {
                                  event: 'click_navigation',
                                  event_info: {
                                    click_location: 'hamburger',
                                    click_category: oneTitle,
                                    click_sub_category: twoTitle,
                                    click_label: el.label,
                                  },
                                },
                              }
                              if (isAppView) {
                                sendSetAppsflyerEvent({
                                  eventName: 'click_navigation',
                                  eventType: {
                                    click_location: 'hamburger',
                                    click_category: oneTitle,
                                    click_sub_category: twoTitle,
                                    click_label: el.label,
                                  },
                                })
                              } else {
                                TagManager.dataLayer(gtmNavigateClick)
                              }
                              closeModal()
                            }}
                          >
                            {element.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </ModalWrap>
  )
}

interface typeProps {
  $closing?: boolean
}

export const ModalWrap = styled.div<typeProps>`
  display: flex;
  width: 100%;
  /* height: 100%; */
  /* min-height: ${() => !isMobile && '460px'}; */
  height: ${() => (isMobile ? '100%' : 'auto')};
  position: fixed;
  top: ${() => (isMobile ? '0' : '110px')}; // .pc_on = 84px
  left: 0;
  animation: ${({ $closing }) => (isMobile ? ($closing ? slideRight : slideLeft) : $closing ? slideOutUp : slideInDown)}
    0.3s ease-in-out;
  background-color: white;
  z-index: 12;

  @media screen and (min-width: 768px) {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
    z-index: 15;
  }
`

export const OneDepBtn = styled.span`
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
  padding: 8px 18px;
  background: #f7f7f7;
  border-radius: 25px;
`

export const TwoDepWrap = styled.div`
  padding: 10px 20px;
  min-width: 160px;
`

export const TwoDepContent = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  padding: 0;
`

export const ThreeDepContent = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--colBlack);
`

export const DepBox = styled.div`
  min-height: ${() => isMobile && '492px'};
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 8px;
  /* min-width: 160px; */
`

export const SwiperWrap = styled(Swiper)`
  padding: 0 20px;
  width: 100%;
`
export const SwiperSlideItem = styled(SwiperSlide)`
  width: auto !important;
`
